import axios from 'axios';

export const uploadFileToUrl = async ({
  file,
  url,
}: {
  file: File;
  url: string;
}) => {
  if (!file) {
    return;
  }

  return await axios({
    url,
    method: 'put',
    data: file,
    maxContentLength: 100 * 1024 * 1024 * 1024,
    timeout: 30 * 60 * 1000,
  });
};
